"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeSubscription = exports.InstallmentSubscription = exports.Referral = exports.PendingSubscription = exports.Payment = exports.PaymentOffering = exports.PausedSubscriptionStatus = exports.PausedSubscription = exports.OMalleyBeneficiary = exports.BulkSubscription = exports.UpdateSubscriptionDto = exports.PauseDuration = exports.PauseAction = exports.UpdateSubscriptionPauseDto = exports.SubscriptionCancelDto = exports.RefundDto = exports.PauseSubscriptionDto = exports.CreateSubscriptionDto = exports.ApplyCouponDto = exports.UpdateCardDto = exports.PreviewSubscriptionUpdateDto = exports.PreviewItemDto = exports.CreatePaymentIntentDto = exports.CreatePaymentIntentResponseDto = exports.GiftSubRequestDto = exports.StripeSubscriptionResponse = exports.PendingSubscriptionResponse = exports.PaymentResponseModel = exports.MoneyModel = exports.InstallmentDetailsModel = exports.GiftSubscriptionResponse = exports.StripeSubscriptionStatus = exports.RedeemType = exports.BulkSubscriptionStatus = exports.GetBulkSubscriptionDto = exports.CreateBulkSubscriptionResponseDto = exports.CreateBulkSubscriptionDto = void 0;
class CreateBulkSubscriptionDto {
}
exports.CreateBulkSubscriptionDto = CreateBulkSubscriptionDto;
class CreateBulkSubscriptionResponseDto {
}
exports.CreateBulkSubscriptionResponseDto = CreateBulkSubscriptionResponseDto;
class GetBulkSubscriptionDto {
}
exports.GetBulkSubscriptionDto = GetBulkSubscriptionDto;
var BulkSubscriptionStatus;
(function (BulkSubscriptionStatus) {
    BulkSubscriptionStatus["PENDING"] = "pending";
    BulkSubscriptionStatus["COMPLETED"] = "completed";
    BulkSubscriptionStatus["FAILED"] = "failed";
})(BulkSubscriptionStatus = exports.BulkSubscriptionStatus || (exports.BulkSubscriptionStatus = {}));
var RedeemType;
(function (RedeemType) {
    RedeemType["DISCOUNT"] = "10% DISCOUNT";
    RedeemType["VOUCHER"] = "VOUCHER";
})(RedeemType = exports.RedeemType || (exports.RedeemType = {}));
var StripeSubscriptionStatus;
(function (StripeSubscriptionStatus) {
    StripeSubscriptionStatus["Active"] = "active";
    StripeSubscriptionStatus["Trial"] = "trial";
    StripeSubscriptionStatus["PastDue"] = "past_due";
    StripeSubscriptionStatus["Deleted"] = "deleted";
    StripeSubscriptionStatus["Cancelled"] = "cancelled";
    StripeSubscriptionStatus["Unknown"] = "unknown";
})(StripeSubscriptionStatus = exports.StripeSubscriptionStatus || (exports.StripeSubscriptionStatus = {}));
class GiftSubscriptionResponse {
}
exports.GiftSubscriptionResponse = GiftSubscriptionResponse;
class InstallmentDetailsModel {
}
exports.InstallmentDetailsModel = InstallmentDetailsModel;
class MoneyModel {
}
exports.MoneyModel = MoneyModel;
class PaymentResponseModel {
    constructor() {
        this.type = 'payment';
    }
}
exports.PaymentResponseModel = PaymentResponseModel;
class PendingSubscriptionResponse {
}
exports.PendingSubscriptionResponse = PendingSubscriptionResponse;
class StripeSubscriptionResponse extends PaymentResponseModel {
    constructor() {
        super(...arguments);
        this.type = 'stripe';
    }
}
exports.StripeSubscriptionResponse = StripeSubscriptionResponse;
class GiftSubRequestDto {
}
exports.GiftSubRequestDto = GiftSubRequestDto;
class CreatePaymentIntentResponseDto {
}
exports.CreatePaymentIntentResponseDto = CreatePaymentIntentResponseDto;
class CreatePaymentIntentDto {
}
exports.CreatePaymentIntentDto = CreatePaymentIntentDto;
class PreviewItemDto {
}
exports.PreviewItemDto = PreviewItemDto;
class PreviewSubscriptionUpdateDto {
}
exports.PreviewSubscriptionUpdateDto = PreviewSubscriptionUpdateDto;
class UpdateCardDto {
}
exports.UpdateCardDto = UpdateCardDto;
class ApplyCouponDto {
}
exports.ApplyCouponDto = ApplyCouponDto;
class CreateSubscriptionDto {
    constructor() {
        this.extraMetadata = {};
    }
}
exports.CreateSubscriptionDto = CreateSubscriptionDto;
class PauseSubscriptionDto {
}
exports.PauseSubscriptionDto = PauseSubscriptionDto;
class RefundDto {
}
exports.RefundDto = RefundDto;
class SubscriptionCancelDto {
}
exports.SubscriptionCancelDto = SubscriptionCancelDto;
class UpdateSubscriptionPauseDto {
}
exports.UpdateSubscriptionPauseDto = UpdateSubscriptionPauseDto;
var PauseAction;
(function (PauseAction) {
    PauseAction["PAUSE"] = "pause";
    PauseAction["RESUME"] = "resume";
})(PauseAction = exports.PauseAction || (exports.PauseAction = {}));
var PauseDuration;
(function (PauseDuration) {
    PauseDuration[PauseDuration["ONE_MONTH"] = 1] = "ONE_MONTH";
    PauseDuration[PauseDuration["THREE_MONTHS"] = 3] = "THREE_MONTHS";
    PauseDuration[PauseDuration["SIX_MONTHS"] = 6] = "SIX_MONTHS";
})(PauseDuration = exports.PauseDuration || (exports.PauseDuration = {}));
class UpdateSubscriptionDto {
}
exports.UpdateSubscriptionDto = UpdateSubscriptionDto;
class BulkSubscription {
}
exports.BulkSubscription = BulkSubscription;
class OMalleyBeneficiary {
}
exports.OMalleyBeneficiary = OMalleyBeneficiary;
class PausedSubscription {
}
exports.PausedSubscription = PausedSubscription;
var PausedSubscriptionStatus;
(function (PausedSubscriptionStatus) {
    PausedSubscriptionStatus["PENDING"] = "pending";
    PausedSubscriptionStatus["PAUSED"] = "paused";
    PausedSubscriptionStatus["CANCELLED"] = "cancelled";
    PausedSubscriptionStatus["RESUMED"] = "resumed";
})(PausedSubscriptionStatus = exports.PausedSubscriptionStatus || (exports.PausedSubscriptionStatus = {}));
class PaymentOffering {
}
exports.PaymentOffering = PaymentOffering;
class Payment {
}
exports.Payment = Payment;
class PendingSubscription {
}
exports.PendingSubscription = PendingSubscription;
class Referral {
}
exports.Referral = Referral;
class InstallmentSubscription {
}
exports.InstallmentSubscription = InstallmentSubscription;
class StripeSubscription extends Payment {
}
exports.StripeSubscription = StripeSubscription;
